// AB#1974 C9 — single ChartJS font configuration for every chart.
// Import for side effect BEFORE rendering any chart. @fontsource registers
// the family as 'Inter Variable' (not 'Inter'); Arabic tick/tooltip glyphs
// fall through per-glyph to 'Noto Sans Arabic Variable'. Family only — no
// size/weight changes (C9).
import { Chart } from 'chart.js';

Chart.defaults.font.family =
    "'Inter Variable', 'Noto Sans Arabic Variable', system-ui, sans-serif";
